/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect,useState, useRef } from 'react'

import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import moment from 'moment'
type Props = {
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const ImportantLinks: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [selectedOption, setSelectedOption] = useState<string>('Select the devision'); 
  
  const [selectedOptionZone, setSelectedOptionZone] = useState<string>('1');// Initialize with 'Total' or any default option
  let [selectedData, setSelectedData] = useState<any>([]);
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // setSelectedOption(event.target.value);
    const selectedValue = event.target.value;
    console.log(selectedValue,"selectedOption");
    // outletCoverd(selectedValue)
    setSelectedOption(selectedValue)
    
  };

  // const handleSelectChangeZone = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   // setSelectedOption(event.target.value);
  //   const selectedValue = event.target.value;
  //   console.log(selectedValue,"selectedOption");
  //   OrderCoverd(selectedValue)
  //   setSelectedOptionZone(selectedValue)
    
  // };
  // useEffect(()=>{
  //   Scorecard()
  // },[])

  const [skucount, setSkucount] = useState<number | undefined>(undefined);
  const [outletcount, setOutletcount] = useState<number | undefined>(undefined);
  const [targetcount, setTargetcount] = useState<number | undefined>(undefined);
  const [activitycoverage, setActivitycoverage] = useState<number | undefined>(undefined);
  const [ordercoverage, setOrdercoverage] = useState<number | undefined>(undefined);
  const [totalscore, setTotalscore] = useState<number | undefined>(undefined);

 

  const Scorecard = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
  
      const raw = JSON.stringify({
        "enterBy": employeeCode,
        "divid": selectedOption
      });
  
      const requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
  
      const response = await fetch("https://crm.romsons.com:8080/ScoreCrad", requestOptions);
      const { data } = await response.json();
  
      const { SkuCount, beat_count, Target_Count, Activity_Count, Order_Count } = data[0];
  
      const totalscore = ((Number(Activity_Count) + Number(Order_Count)) / Number(Target_Count)) * 100;
      
      // Define your state variables here with useState
   
  
      if (totalscore !== undefined) {
        setSkucount(SkuCount);
        setOutletcount(beat_count);
        setTargetcount(Target_Count);
        setActivitycoverage(Activity_Count);
        setOrdercoverage(Order_Count);
        setTotalscore(totalscore);
      }
  
      console.log(totalscore, "score");
    } catch (error) {
      console.error('error', error);
    }
  };
  
  const [employeeCode, setEmployeeCode] = useState<string>('');
  
  const handleEmployeeCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Update the state variable with the new input value
    setEmployeeCode(event.target.value);
  };
  const currentDate = moment();
  const currentMonth = currentDate.format('MMMM-YYYY');
  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
           

            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>Score Card</span>

          
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>Division & Employee wise Information</span>
          <span className='text-dark pt-1 fw-semibold fs-6'>  {currentMonth}  ( {Number(totalscore).toFixed(0)} %)</span>        </div>
      </div>
      <label>Select devision</label>
      <select value={selectedOption} onChange={handleSelectChange}>
      <option value='Select the devision'>Select the devision</option>
              <option value='1'>Retail</option>
              <option value='2'>MSD</option>
              <option value='3'>KAD</option>
              <option value='6'>OPS</option>
              <option value='7'>GOVT</option>
              <option value='5'>GTD</option>
              {/* Add more options as needed */}
            </select>
<br/>
<div className="flex items-center space-x-2">
  <input
    className="border border-gray-300 rounded px-2 py-1"
    placeholder="Enter Employee code"
    value={employeeCode} // Bind the input value to the state variable
    onChange={handleEmployeeCodeChange}
  />
  <button className="bg-blue-500 text-black px-3 py-1 rounded" onClick={Scorecard}>Search</button>
</div>
{/* <label>Select devision</label>
           <input placeholder='Enter Employee code '/>
           <button>Search</button> */}

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
      

        <div className='d-flex flex-column content-justify-center flex-row-fluid'>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>SkuCount</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'> {skucount}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Beat Count</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{outletcount}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Activity Count</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{activitycoverage}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Order Count</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{ordercoverage}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Target Count</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{targetcount}</div>
          </div>
         
       
          
        
        </div>
      </div>
    </div>
  )
}



export { ImportantLinks }
